// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.delimiter_wrapper__3ajt- {
  display: flex;
  align-items: center;
}

.delimiter_text__rY0wk {
  font-size: 12px;
  font-weight: 500;
  color: var(--mui-palette-grey-700);
  padding-right: 10px;
}

.delimiter_delimiter__J25J4 {
  height: 1px;
  border-bottom: 1px solid var(--mui-palette-grey-300);
  flex: 1 1;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui/dist/delimiter/delimiter.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,oDAAoD;EACpD,SAAO;AACT","sourcesContent":[".wrapper {\n  display: flex;\n  align-items: center;\n}\n\n.text {\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--mui-palette-grey-700);\n  padding-right: 10px;\n}\n\n.delimiter {\n  height: 1px;\n  border-bottom: 1px solid var(--mui-palette-grey-300);\n  flex: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `delimiter_wrapper__3ajt-`,
	"text": `delimiter_text__rY0wk`,
	"delimiter": `delimiter_delimiter__J25J4`
};
export default ___CSS_LOADER_EXPORT___;
